
<template>

    <!-- Page -->
    <main class="page" id="staticPage">

        <div class="container">

            <component  :is="currentPage" :page="page"></component>

        </div>

    </main>

</template>

<script>
    import About from './custom/About';
    import Default from './custom/Default';
    import Blank from './custom/Blank';
    import {mapActions} from 'vuex'

    export default {
        components: {
            About,
            Blank,
            Default
        },
        data () {
            return {
                currentPage: "Blank",
                currentUrl: window.location.href,
                page: null,
            }
        },
        created: function() {
        },
        methods: {

            ...mapActions([
                'loadBanners'
            ]),

            stripHTML: function(html) {
                return html.replace(/<(?:.|\n)*?>/gm, '');
            },

            displayImage: function(image, width, height) {

                if(!image) return "";

                return window.cms + image.display +
                    (width !== null && typeof width !== "undefined" && !isNaN(width) ? "?w=" + width : "") +
                    (height !== null && typeof height !== "undefined" && !isNaN(height) ?
                        (width !== null && typeof width !== "undefined" && !isNaN(width) ? "&" : "?") + "h=" + height : "");
            },

            encodeUrl: function(str) {

                str = str.replace(/^\s+|\s+$/g, ''); // trim
                str = str.toLowerCase();

                // remove accents, swap ñ for n, etc
                let from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
                let to   = "aaaaeeeeiiiioooouuuunc------";
                for (let i=0, l=from.length ; i<l ; i++) {
                    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
                }

                str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
                    .replace(/\s+/g, '-') // collapse whitespace and replace by -
                    .replace(/-+/g, '-'); // collapse dashes

                return str;
            },

            sloDate: function(date) {

                // 15th february 2018
                return moment(date).format("Do MMMM YYYY");
            },

            getBanners: function() {

                let handle = this;
                let mainBackgroundImage = document.getElementById("mainBackgroundImage");

                this.loadBanners().then(function(banners) {

                    if(banners.length > 0 && banners[0].image !== null && typeof banners[0].image !== "undefined") {

                        mainBackgroundImage.style.backgroundImage = "url("+handle.displayImage(banners[0].image, 2200)+")";
                    }
                });
            }

        },
        mounted: function() {

            let handle = this;

            jQuery(document).ready(function() {

                let data = (getParameterByName("edit") ? { edit:true } : {});

                jQuery.ajax({
                    url: window.cms + "page/getBySEO/"+handle.$route.params.id + (handle.$route.name === "edit" || getParameterByName("preview") ? "?edit=true" : ""),
                    type: "get",
                    dataType: "json",
                    data: data,
                    success: function(data) {

                        handle.page = data;
                        window.currentItemId = handle.page.id;
                        handle.currentPage = handle.page.template;

                        if(typeof QRGenerator !== "undefined") {

							let qrGen = new QRGenerator({
								formCustomClass: "neki-opa",
								inputCustomClass: "form-control"
							});
							qrGen.init();
						}

                    }
                }).fail(function(error) {

                    console.log("Error getting blog");
                    console.log(error);
                    console.log(error.responseText);
                });
            });

            this.getBanners();

        },

        metaInfo: function() {

            let handle = this;

            return {

                title: window.seo.name,
                titleTemplate: '%s' + (handle.page && handle.page.seo ? " - " + handle.page.seo.title : ""),
                meta: [
                    { author : window.seo.author },
                    { description : (handle.page && handle.page.seo ? handle.page.seo.description.replace(/\n/g, ' ').trim() : window.seo.description) },
                    { keywords : (handle.page && handle.page.seo ? handle.page.seo.keywords : window.seo.keywords) },

                    // Facebook
                    {property: 'og:title', content:  (handle.page && handle.page.seo ? handle.page.seo.title : window.seo.title) },
                    {property: 'og:site_name', content: window.seo.name },
                    {property: 'og:type', content: 'website'},
                    {property: 'og:url', content: (handle.page ? window.seo.url + 'pages/' + handle.page.seo.handle : window.seo.url) },
                    {property: 'og:image', content: (handle.page && handle.page.image ? window.cms + handle.page.image.display : window.seo.image) },
                    {property: 'og:description', content: (handle.page && handle.page.seo ? handle.page.seo.description.replace(/\n/g, ' ').trim() : window.seo.description) },

                    // Twitter card
                    {name: 'twitter:card', content: 'summary'},
                    {name: 'twitter:site', content: (handle.page ? window.seo.url + 'pages/' + handle.page.seo.handle : window.seo.url) },
                    {name: 'twitter:title', content: (handle.page && handle.page.seo ? handle.page.seo.title : window.seo.title) },
                    {name: 'twitter:description', content: (handle.page && handle.page.seo ? handle.page.seo.description.replace(/\n/g, ' ').trim() : window.seo.description) },
                    {name: 'twitter:image:src', content: (handle.page && handle.page.image ? window.cms + handle.page.image.display : window.seo.image) },

                    // Google / Schema.org markup:
                    {itemprop: 'name', content: (handle.page && handle.page.seo ? handle.page.seo.title : window.seo.name) },
                    {itemprop: 'description', content: (handle.page && handle.page.seo ? handle.page.seo.description.replace(/\n/g, ' ').trim() : window.seo.description) },
                    {itemprop: 'image', content: (handle.page && handle.page.image ? window.cms + handle.page.image.display : window.seo.image) }
                ],
                links: [
                    {rel: 'canonical', href: (handle.page ? window.seo.url + 'pages/' + handle.page.seo.handle : window.seo.url) }
                ]
            }
        },
    };

</script>

<style lang="scss">


</style>



// WEBPACK FOOTER //
// src/pages/Pages.vue